import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=2d3bea86&scoped=true&"
import script from "./projectOverview.vue?vue&type=script&lang=js&"
export * from "./projectOverview.vue?vue&type=script&lang=js&"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=2d3bea86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bea86",
  null
  
)

export default component.exports